import { atom } from 'jotai';

import { Maybe, SelectValue } from '@/types';

export type RegisterSchoolData = {
  playTde: boolean;
  isPrimary: boolean;
  province: Maybe<SelectValue>;
  schools: Maybe<SelectValue>;
  party: Maybe<SelectValue>;
  location: Maybe<SelectValue>;
};

export const registerAtom = atom<Maybe<RegisterSchoolData>>(null);
